/**
 * Page3 Component
 *
 * This component returns a page that contains a detailed description of the third item in the project list.
 */

import React from "react";

const Page3 = () => {
  return (
    <div className="page-content">
      <h2>Title 3</h2>
      <p>Additional content for the third item.</p>
    </div>
  );
};

export default Page3;
